import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export default function AdminAuthWrapper(props: any) {
  const router = useRouter();
  const userToken = useSelector((state: any) => {
    return state.adminAuth?.accessToken;
  });

  useEffect(() => {
    if (userToken) {
      router.push("/");
    } else {
      router.push("/login");
    }
  }, []);

  return userToken ? null : props.children;
}
